<template>
  <!-- prettier-ignore -->
  <div class="replace">
    <ovp-typography
      type="heading04"
      v-text="$t('product.replace.title')"
    />
    <ovp-typography
      type="body04"
      v-text="$t('product.replace.subtitle')"
    />

    <div class="replace-products">
      <div class="replace-product">
        <ovp-typography
          type="heading04"
          v-text="$t('product.replace.selectable')"
        />
        <ovp-replace-product
          v-if="to"
          :group-id="to.groupId"
          :person-id="personId"
          :product="to.product"
          :product-id="to.productId"
          :selected="true"
          @replace="$emit('replace', to.product)"
        />
        <ovp-loading v-else />
      </div>

      <div class="replace-product">
        <ovp-typography
          type="heading04"
          v-text="$t('product.replace.selected')"
        />
        <ovp-replace-product
          v-if="from"
          :group-id="from.groupId"
          :person-id="personId"
          :product="from.product"
          :product-id="from.productId"
          :selected="false"
        />
        <ovp-loading v-else />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import OvpReplaceProduct from '@/components/Product/Replace/Product'
import OvpLoading from '@/components/Container/LoadingAlt'

import { BasketHelper } from '@/helpers'

export default {
  name: 'OvpReplace',

  components: {
    OvpReplaceProduct,
    OvpLoading,
  },

  props: {
    groupId: {
      type: String,
      required: true,
    },

    fromProductId: {
      type: String,
      required: true,
    },

    toProductId: {
      type: String,
      required: true,
    },

    personId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      from: null,
      to: null,
    }
  },

  mounted() {
    this.simulate(this.personId, this.fromProductId, this.toProductId)
  },

  computed: {
    ...mapState(['basket']),
    ...mapGetters('products', ['getGroupIdFromProduct']),
    ...mapGetters('basket', ['getProduct', 'getProductPrice']),
  },

  methods: {
    simulate(personId, fromProductId, toProductId) {
      const selectedOption = this.getProductPrice(personId, fromProductId)

      BasketHelper.simulateUpdate(
        personId,
        [fromProductId],
        [{ id: toProductId, criteria: { ...selectedOption } }]
      ).then(response => {
        window.setTimeout(() => {
          this.from = {
            productId: this.fromProductId,
            product: response.persons.find(p => p.personId === personId).products.products[this.fromProductId],
            groupId: this.getGroupIdFromProduct(this.fromProductId),
          }
          this.to = {
            productId: this.toProductId,
            product: response.persons.find(p => p.personId === personId).products.products[this.toProductId],
            groupId: this.groupId,
          }
        }, 250)
      })
    },
  },
}
</script>

<style name="mobile" scoped>
.replace {
  margin: 15px;

  &-products {
    display: grid;
    gap: 50px;
    padding: 0 0 20px 0;
    margin: 16px 0 0 0;
  }

  &-product {
    flex: 1 1 100%;

    .product {
      margin: 8px 0 0 0;
      border: 1px solid var(--c-black);
    }
  }
}
</style>

<style name="desktop" scoped>
@media (--md) {
  .replace {
    margin: 20px;

    &-products {
      grid-template-columns: 1fr 1fr;
      gap: 24px;
    }
  }
}
</style>